import { render, staticRenderFns } from "./EmailField.vue?vue&type=template&id=6e960f58&scoped=true&"
import script from "./EmailField.vue?vue&type=script&lang=js&"
export * from "./EmailField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e960f58",
  null
  
)

export default component.exports